import get from 'lodash/get';

import Layout from '../views/containers/layouts/layout';

import IndexPage from '../views/containers/pages/index_page/index_page';
import CategoryPage from '../views/containers/pages/category_page/category_page';
import NewsPage from '../views/containers/pages/category_page/news_page';
import TagPage from '../views/containers/pages/tag_page/tag_page';
import SponsoredKiaTagPage from '../views/containers/pages/tag_page/sponsored_kia_tag_page';

import SponsoredTagPageCustom from '../views/containers/pages/tag_page/sponsored_tag_page_custom';

import NotFound from '../views/containers/pages/not_found_page/not_found_page';
import SearchPage from '../views/containers/pages/search_page/search_page';
import PostPage from '../views/containers/pages/post_page/post_page';
import AuthorPage from '../views/containers/pages/author_page/author_page';
import PersonPage from '../views/containers/pages/person_page/person_page';

import ProductPage from '../views/containers/pages/product_page/product_page';

import PersonIndexSectionPage from '../views/containers/pages/person_index_section_page/person_index_section_page';
import ProductIndexSectionPage from '../views/containers/pages/product_index_section_page/product_index_section_page';

import MostCreativePeopleCommunitySectionPage from '../views/containers/pages/most_creative_people_community_section_page/most_creative_people_community_section_page';
import MostCreativePeoplePage from '../views/containers/pages/most_creative_people_page/most_creative_people_page';
import InnovationByDesignPage from '../views/containers/pages/innovation_by_design_page/innovation_by_design_page';
import WpPage from '../views/containers/pages/wp_page/wp_page';
import NewslettersPage from '../views/containers/pages/newsletters_page/newsletters_page';
import HtmlSitemapIndexPage from '../views/containers/pages/html_sitemap_index_page/html_sitemap_index_page';
import HtmlSitemapPostPage from '../views/containers/pages/html_sitemap_post_page/html_sitemap_post_page';
import MagazineArchivePage from '../views/containers/pages/magazine_archive_page/magazine_archive_page';
import VideoPage from '../views/containers/pages/video_page/video_page';
import PlaylistIndexPage from '../views/containers/pages/playlist_index_page/playlist_index_page';
import VideoIndexPage from '../views/containers/pages/video_index_page/video_index_page';
import PlaylistPage from '../views/containers/pages/playlist_page/playlist_page';

import CompanyPage from '../views/containers/pages/company_page/company_page';
import CompanyIndexPage from '../views/containers/pages/company_index_page/company_index_page';
import CompanyIndexSectionPage from '../views/containers/pages/company_index_section_page/company_index_section_page';

import MicYearPage from '../views/containers/pages/mic_year_page/mic_year_page';

import videoIndexPageStateManager from './route_state_managers/video_index_page_state_manager';
import playlistIndexPageStateManager from './route_state_managers/playlist_index_page_state_manager';
import playlistPageStateManager from './route_state_managers/playlist_page_state_manager';
import videoPageStateManager from './route_state_managers/video_page_state_manager';
import postPageStateManager from './route_state_managers/postpage_state_manager';
import homepagePageStateManager from './route_state_managers/homepage_state_manager';
import categoryPageStateManager from './route_state_managers/category_page_state_manager';
import tagPageStateManager from './route_state_managers/tag_page_state_manager';
import mostCreativePeoplePageStateManager from './route_state_managers/most_creative_people_page_state_manager';
import innovationByDesignPageStateManager from './route_state_managers/innovation_by_design_page_state_manager';
import personPageStateManager from './route_state_managers/person_page_state_manager';
import productPageStateManager from './route_state_managers/product_page_state_manager';

import personIndexPageStateManager from './route_state_managers/person_index_page_state_manager';
import productIndexPageStateManager from './route_state_managers/product_index_page_state_manager';
import productIndexSectionPageStateManager from './route_state_managers/product_index_section_page_state_manager';

import personIndexSectionPageStateManager from './route_state_managers/person_index_section_page_state_manager';
import mostCreativePeopleCommunityPageStateManager from './route_state_managers/most_creative_people_community_page_state_manager';
import mostCreativePeopleCommunitySectionPageStateManager from './route_state_managers/most_creative_people_community_section_page_state_manager';
import authorPageStateManager from './route_state_managers/author_page_state_manager';
import searchPageStateManager from './route_state_managers/search_page_state_manager';
import wpPageStateManager from './route_state_managers/wp_page_state_manager';
import staticPageStateManager from './route_state_managers/static_page_state_manager';
import notFoundPageStateManager from './route_state_managers/not_found_page_state_manager';
import htmlSitemapIndexPageStateManager from './route_state_managers/html_sitemap_index_page_state_manager';
import htmlSitemapPostPageStateManager from './route_state_managers/html_sitemap_post_page_state_manager';
import magazineArchivePageStateManager from './route_state_managers/magazine_archive_page_state_manager';

import companyPageStateManager from './route_state_managers/company_page_state_manager';
import companyIndexPageStateManager from './route_state_managers/company_index_page_state_manager';
import companyIndexSectionPageStateManager from './route_state_managers/company_index_section_page_state_manager';

import micYearPageStateManager from './route_state_managers/mic_year_page_state_manager';

export default function getRoutesWithStore(store) {
  const state = store.getState();
  const routeConfig = [
    {
      component: Layout,
      routes: [
        {
          path: '/about-us',
          component: WpPage,
          exact: true,
          strict: true,
          loadData: wpPageStateManager(store)
        },
        {
          path: '/apply/:slug',
          component: WpPage,
          exact: true,
          strict: true,
          loadData: wpPageStateManager(store)
        },
        {
          path: '/newsletters',
          component: NewslettersPage,
          exact: true,
          strict: true,
          loadData: staticPageStateManager(store)
        },
        {
          path: '/contact-us',
          component: WpPage,
          exact: true,
          strict: true,
          loadData: wpPageStateManager(store)
        },
        {
          path: '/staff-masthead',
          component: WpPage,
          exact: true,
          strict: true,
          loadData: wpPageStateManager(store)
        },
        {
          path: '/privacy-policy',
          component: WpPage,
          exact: true,
          strict: true,
          loadData: wpPageStateManager(store)
        },
        {
          path: '/terms-and-conditions',
          component: WpPage,
          exact: true,
          strict: true,
          loadData: wpPageStateManager(store)
        },
        {
          path: '/search/:q/:page',
          component: SearchPage,
          exact: true,
          strict: true,
          loadData: searchPageStateManager(store)
        },
        {
          path: '/search/:q',
          component: SearchPage,
          exact: true,
          strict: true,
          loadData: searchPageStateManager(store)
        },
        {
          path: '/search',
          component: SearchPage,
          loadData: searchPageStateManager(store)
        },
        {
          path: '/sitemap',
          component: HtmlSitemapIndexPage,
          exact: true,
          strict: true,
          loadData: htmlSitemapIndexPageStateManager(store)
        },
        {
          path: '/sitemap/year/:year',
          component: HtmlSitemapIndexPage,
          exact: true,
          strict: true,
          loadData: htmlSitemapIndexPageStateManager(store)
        },
        {
          path: '/sitemap/posts',
          component: HtmlSitemapPostPage,
          exact: true,
          strict: true,
          loadData: htmlSitemapPostPageStateManager(store)
        },
        {
          path: '/section/living-smarter',
          component: SponsoredKiaTagPage,
          exact: true,
          strict: true,
          loadData: tagPageStateManager(store, 'living-smarter')
        },
        {
          path: '/section/urban-x',
          component: SponsoredTagPageCustom,
          exact: true,
          strict: true,
          loadData: tagPageStateManager(store, 'urban-x')
        },
        {
          path: '/section/:tag',
          component: TagPage,
          exact: true,
          strict: true,
          loadData: tagPageStateManager(store)
        },
        {
          path: '/product/:product',
          component: ProductPage,
          exact: true,
          strict: true,
          loadData: productPageStateManager(store)
        },
        {
          path: '/innovation-by-design/:year',
          component: InnovationByDesignPage,
          exact: true,
          strict: true,
          loadData: innovationByDesignPageStateManager(store)
        },
        {
          path: '/person',
          component: PersonIndexSectionPage,
          exact: true,
          strict: true,
          autoScrollOff: true,
          loadData: personIndexPageStateManager(store)
        },
        {
          path: '/person/:section/:page',
          component: PersonIndexSectionPage,
          exact: true,
          strict: true,
          autoScrollOff: true,
          loadData: personIndexSectionPageStateManager(store)
        },
        {
          path: '/most-creative-people-community',
          component: MostCreativePeopleCommunitySectionPage,
          exact: true,
          strict: true,
          autoScrollOff: true,
          loadData: mostCreativePeopleCommunityPageStateManager(store)
        },
        {
          path: '/most-creative-people-community/:section/:page',
          component: MostCreativePeopleCommunitySectionPage,
          exact: true,
          strict: true,
          autoScrollOff: true,
          loadData: mostCreativePeopleCommunitySectionPageStateManager(store)
        },
        {
          path: '/innovation-by-design-awards/:slug',
          component: WpPage,
          exact: true,
          strict: true,
          autoScrollOff: true,
          loadData: wpPageStateManager(store)
        },
        {
          path: '/person/:person',
          component: PersonPage,
          exact: true,
          strict: true,
          loadData: personPageStateManager(store)
        },
        {
          path: '/most-creative-people/:year',
          component: MostCreativePeoplePage,
          exact: true,
          strict: true,
          loadData: mostCreativePeoplePageStateManager(store)
        },
        {
          path: '/company/:company',
          component: CompanyPage,
          exact: true,
          strict: true,
          loadData: companyPageStateManager(store)
        },
        {
          path: '/tag/:tag',
          component: TagPage,
          exact: true,
          strict: true,
          loadData: tagPageStateManager(store)
        },
        {
          path: '/magazine/archives',
          component: MagazineArchivePage,
          exact: true,
          strict: true,
          loadData: magazineArchivePageStateManager(store)
        },
        {
          path: '/magazine/:tag',
          component: TagPage,
          exact: true,
          strict: true,
          loadData: tagPageStateManager(store, 'magazine')
        },
        {
          path: '/user/:slug',
          component: AuthorPage,
          exact: true,
          strict: true,
          loadData: authorPageStateManager(store)
        },
        {
          path: '/pvw/:id/:slug',
          component: PostPage,
          exact: true,
          strict: true,
          loadData: postPageStateManager(store)
        },
        {
          path: '/pvw/:id/:section/:slug',
          component: PostPage,
          exact: true,
          strict: true,
          loadData: postPageStateManager(store)
        },
        {
          path: '/:category',
          component: CategoryPage,
          strict: true,
          exact: true,
          loadData: categoryPageStateManager(store)
        },
        {
          path: '/:id/:slug',
          component: PostPage,
          exact: true,
          strict: true,
          loadData: postPageStateManager(store)
        },
        {
          path: '/:id/:section/:slug',
          component: PostPage,
          exact: true,
          strict: true,
          loadData: postPageStateManager(store)
        },
        {
          path: '/:id/:section/:slug/:pageNumber',
          component: PostPage,
          exact: true,
          strict: true,
          loadData: postPageStateManager(store)
        },
        {
          path: '/',
          component: IndexPage,
          exact: true,
          strict: true,
          loadData: homepagePageStateManager(store)
        },
        {
          component: NotFound,
          loadData: notFoundPageStateManager(store)
        }
      ]
    }
  ];

  if (get(state, 'config.featureFlags.newsPageEnable')) {
    routeConfig[0].routes.unshift({
      path: '/news',
      component: NewsPage,
      strict: true,
      exact: true,
      loadData: categoryPageStateManager(store, 'news')
    });
  }

  if (get(state, 'config.featureFlags.videoPagesEnabled')) {
    routeConfig[0].routes.unshift({
      path: '/videos',
      component: VideoIndexPage,
      exact: true,
      strict: true,
      loadData: videoIndexPageStateManager(store)
    });

    routeConfig[0].routes.unshift({
      path: '/videos/playlists',
      component: PlaylistIndexPage,
      exact: true,
      strict: true,
      loadData: playlistIndexPageStateManager(store)
    });

    routeConfig[0].routes.unshift({
      path: '/videos/playlist/:playlistTitle/:playlistId/:page',
      component: PlaylistPage,
      exact: true,
      strict: true,
      loadData: playlistPageStateManager(store)
    });

    routeConfig[0].routes.unshift({
      path: '/videos/playlist/:playlistTitle/:playlistId',
      component: PlaylistPage,
      exact: true,
      strict: true,
      loadData: playlistPageStateManager(store)
    });

    routeConfig[0].routes.unshift({
      path: '/video/:slug/:id',
      component: VideoPage,
      exact: true,
      strict: true,
      loadData: videoPageStateManager(store)
    });
  }

  if (get(state, 'config.featureFlags.micPagesEnabled')) {
    routeConfig[0].routes.unshift({
      path: '/company/:section/:page',
      component: CompanyIndexSectionPage,
      exact: true,
      strict: true,
      loadData: companyIndexSectionPageStateManager(store)
    });

    /* routeConfig[0].routes.unshift({
      path: '/company/:company',
      component: CompanyPage,
      exact: true,
      strict: true,
      loadData: companyPageStateManager(store)
    }); */

    routeConfig[0].routes.unshift({
      path: '/company',
      component: CompanyIndexPage,
      exact: true,
      strict: true,
      loadData: companyIndexPageStateManager(store)
    });

    // routeConfig[0].routes.unshift({
    //   path: '/most-innovative-companies/:year/sectors',
    //   component: MicSectorYearPage,
    //   exact: true,
    //   strict: true,
    //   loadData: micSectorYearPageStateManager(store)
    // });

    routeConfig[0].routes.unshift({
      path: '/most-innovative-companies/:year/sectors/:sector',
      component: MicYearPage,
      exact: true,
      strict: true,
      loadData: micYearPageStateManager(store),
      autoScrollOff: true
    });

    routeConfig[0].routes.unshift({
      path: '/most-innovative-companies/:year',
      component: MicYearPage,
      exact: true,
      strict: true,
      loadData: micYearPageStateManager(store),
      autoScrollOff: true
    });

    // routeConfig[0].routes.unshift({
    //   path: '/most-innovative-companies/:year/:page',
    //   component: MicYearPage,
    //   exact: true,
    //   strict: true,
    //   loadData: micYearPageStateManager(store)
    // });
  }

  routeConfig[0].routes.unshift({
    path: '/stuff/:section/:page',
    component: ProductIndexSectionPage,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: productIndexSectionPageStateManager(store)
  });

  routeConfig[0].routes.unshift({
    path: '/stuff',
    component: ProductIndexSectionPage,
    exact: true,
    strict: true,
    loadData: productIndexPageStateManager(store)
  });

  if (get(state, 'config.featureFlags.categoryPagination')) {
    routeConfig[0].routes.unshift({
      path: '/category/:category/:page',
      component: CategoryPage,
      strict: true,
      exact: true,
      loadData: categoryPageStateManager(store)
    });
  }

  return routeConfig;
}



// WEBPACK FOOTER //
// ./src/react_router/react_router.js